"use strict";
/* Copyright (c) 2018, Oracle and/or its affiliates. All Rights Reserved. */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * OUI progress bar component.
 * A progress bar is a visual indicator of a currently running task.
 * It shows the current value of progress, the current step being performed as well as a label for the overall task.
 *
 * @oui-component ProgressBar
 */
var ProgressBar = function (props) {
    var _a = props.max, max = _a === void 0 ? 100 : _a, value = props.value, label = props.label, stepLabel = props.stepLabel, progressLabel = props.progressLabel;
    var ariaValues = {
        "aria-valuenow": Math.abs(value),
        "aria-valuemax": Math.abs(max)
    };
    return (React.createElement("div", { className: "oui-progress-bar" },
        React.createElement("div", { className: "oui-progress-bar__labels" },
            label && (React.createElement("div", { className: "oui-progress-bar__labels__label" }, label)),
            stepLabel && (React.createElement("div", { className: "oui-progress-bar__labels__stepLabel" },
                React.createElement("span", null, stepLabel)))),
        React.createElement("progress", __assign({ max: Math.abs(max), value: Math.abs(value), className: "oui-progress-bar__progress" }, ariaValues)),
        progressLabel && (React.createElement("div", { className: "oui-progress-bar__progressLabel" }, progressLabel))));
};
exports.default = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map